import { render, staticRenderFns } from "./CategoryProducts.vue?vue&type=template&id=44d3f48e&scoped=true&"
import script from "./CategoryProducts.vue?vue&type=script&lang=js&"
export * from "./CategoryProducts.vue?vue&type=script&lang=js&"
import style0 from "./CategoryProducts.vue?vue&type=style&index=0&id=44d3f48e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44d3f48e",
  null
  
)

export default component.exports